import CrudActionContainer from './CrudActionContainer';
import VariablesController from '../controllers/VariablesController';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler from '../errorHandlers/common-handler';

class VariablesCRUDActions extends CrudActionContainer {
  constructor() {
    super('VARIABLES');
  }

  retrieveAll(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveAllAction));
        const response = await VariablesController.getAll(facebookPageId);
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

const variablesCRUDActions = new VariablesCRUDActions();

export default variablesCRUDActions;
